var _path, _path2, _g, _circle, _path3, _path4, _rect, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcoGif(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 78,
    height: 93,
    viewBox: "0 0 78 93",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6 5C6 2.23858 8.23858 0 11 0H42.931H48.1285C49.4691 0 50.7535 0.538347 51.6935 1.4942L64.0345 14.0436L76.5256 26.4651C77.4694 27.4035 78 28.6795 78 30.0105V55.8624V88C78 90.7614 75.7614 93 73 93H11C8.23857 93 6 90.7614 6 88V5Z",
    fill: "#EDEDED"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_459_291",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 6,
    y: 0,
    width: 72,
    height: 93
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6 5C6 2.23858 8.23858 0 11 0H42.931H48.1285C49.4691 0 50.7535 0.538347 51.6935 1.4942L64.0345 14.0436L76.5256 26.4651C77.4694 27.4035 78 28.6795 78 30.0105V55.8624V88C78 90.7614 75.7614 93 73 93H11C8.23857 93 6 90.7614 6 88V5Z",
    fill: "#EDEDED"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_459_291)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 50,
    y: -29,
    width: 56,
    height: 56,
    fill: "#D9D9D9"
  }))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 49,
    cy: 39,
    r: 3,
    fill: "#6C94FB"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M49.5 46L42 59H57L49.5 46Z",
    fill: "#A7B5D9"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M38.5 39L27 59H50L38.5 39Z",
    fill: "#6C94FB"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 67,
    width: 48,
    height: 20,
    rx: 3,
    fill: "#6C94FB"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M19.9524 75.6442C19.8961 75.4354 19.8132 75.2514 19.7038 75.0923C19.5945 74.9299 19.4602 74.7924 19.3011 74.6797C19.142 74.567 18.9598 74.4825 18.7543 74.4261C18.5488 74.3665 18.3234 74.3366 18.0781 74.3366C17.5843 74.3366 17.1567 74.456 16.7955 74.6946C16.4375 74.9332 16.1607 75.2812 15.9652 75.7386C15.7696 76.1927 15.6719 76.7446 15.6719 77.3942C15.6719 78.0471 15.7663 78.6039 15.9553 79.0646C16.1442 79.5253 16.4176 79.8767 16.7756 80.1186C17.1335 80.3606 17.5677 80.4815 18.0781 80.4815C18.5289 80.4815 18.91 80.4086 19.2216 80.2628C19.5365 80.1136 19.7751 79.9032 19.9375 79.6314C20.0999 79.3596 20.1811 79.0398 20.1811 78.6719L20.6385 78.7266H18.1626V76.9318H22.5526V78.2791C22.5526 79.1906 22.3587 79.9711 21.9709 80.6207C21.5864 81.2704 21.0561 81.7692 20.38 82.1172C19.7071 82.4652 18.9332 82.6392 18.0582 82.6392C17.0871 82.6392 16.2337 82.4287 15.4979 82.0078C14.7621 81.5869 14.1887 80.987 13.7777 80.2081C13.3667 79.4259 13.1612 78.4979 13.1612 77.424C13.1612 76.5888 13.2855 75.848 13.5341 75.2017C13.7827 74.5521 14.129 74.0019 14.5732 73.5511C15.0206 73.1004 15.5376 72.759 16.1243 72.527C16.7143 72.295 17.349 72.179 18.0284 72.179C18.6184 72.179 19.1669 72.2635 19.674 72.4325C20.1844 72.6016 20.6352 72.8402 21.0263 73.1484C21.4207 73.4567 21.7405 73.8229 21.9858 74.2472C22.2311 74.6714 22.3835 75.1371 22.4432 75.6442H19.9524ZM26.464 72.3182V82.5H24.003V72.3182H26.464ZM28.0089 82.5V72.3182H34.9592V74.3168H30.4698V76.4048H34.5167V78.4084H30.4698V82.5H28.0089Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoGif);
export default __webpack_public_path__ + "static/media/ico_gif.5634ed3c9df5ff0185246713be7294ba.svg";
export { ForwardRef as ReactComponent };